<template>
  <v-card flat>
    <v-card-title>{{ deliveryUser ? deliveryUser : 'Mostrador' }}</v-card-title>
    <v-card-text>

      <v-data-table
          :headers="headers"
          :items="report"
          disable-pagination
          hide-default-footer
          show-expand
          :expanded.sync="expanded"
          item-key="method"
      >

        <template v-slot:item.method="{ item }">
          {{$t('delivery.payment.method.'+item.method)}}
        </template>

        <template v-slot:item.itemsAmount="{ item }">
          <b>${{item.itemsAmount.toLocaleString('ES-AR')}}</b>
        </template>

        <template v-slot:item.totalDiscount="{ item }">
          <b>-${{item.totalDiscount.toLocaleString('ES-AR')}}</b>
        </template>

        <template v-slot:item.deliveryCost="{ item }">
          ${{item.deliveryCost.toLocaleString('ES-AR')}}
        </template>


        <template v-slot:item.totalAmount="{ item }">
          ${{item.totalAmount.toLocaleString('ES-AR')}}
        </template>




        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">

            <v-simple-table>
              <thead>
              <tr>
                <th>Número</th>
                <th>Nombre</th>
                <th>Dirección</th>
                <th>Cantidad</th>
                <th>Total Productos</th>
                <th>Descuento</th>
                <th>Costo envío</th>
                <th>Total</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="order in getOrdersByMethod(item.method)"
                  :key="order.number"
              >
                <td>{{ order.number }}</td>
                <td>{{ order.contact ? order.contact.name : '' }}</td>
                <td>{{ order.location ? order.location.address : '' }}</td>
                <td>{{ order.totalQuantity }}</td>
                <td>${{ order.itemsAmount}}</td>
                <td>-${{order.totalDiscount }}</td>
                <td>${{ order.deliveryFree ? 0 : order.delivery.cost }}</td>
                <td>${{ order.totalAmount }}</td>
              </tr>
              </tbody>
            </v-simple-table>

          </td>
        </template>
      </v-data-table>


    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'order-report-detail',
  props: {
    deliveryUser: {},
    orders: {},
    report: {},
  },
  data(){
    return {
      expanded: [],
      headers: [
        {text: 'método', value: 'method'},
        {text: 'cantidad', value: 'quantity'},
        {text: 'Total Productos', value: 'itemsAmount'},
        {text: 'Descuento', value: 'totalDiscount'},
        {text: 'Costo envío', value: 'deliveryCost'},
        {text: 'Total', value: 'totalAmount'},
        {text: '', value: 'data-table-expand'},
      ]
    }
  },
  computed: {
    getOrdersByMethod() {
      return (method) => {
        return this.orders.filter(o => o.payment.method === method)
      }
    },
  }
}
</script>
